export default "__VITE_ASSET__BVDfoS72__"